var map = {
  "./brown-eyed-girl.chopro": "7491",
  "./dont-look-back-in-anger.chopro": "5441",
  "./dont-stop-believin.chopro": "7007",
  "./eye-of-the-tiger.chopro": "6649",
  "./have-you-ever-seen-the-rain.chopro": "6266",
  "./hey-ya.chopro": "3291",
  "./hotel-california.chopro": "4215",
  "./im-yours.chopro": "7363",
  "./jolene.chopro": "5093",
  "./knockin-on-heavens-door.chopro": "6863",
  "./la-bamba.chopro": "8135",
  "./let-it-be.chopro": "1995",
  "./livin-on-a-prayer.chopro": "2150",
  "./mr-brightside.chopro": "6943",
  "./no-woman-no-cry.chopro": "2815",
  "./proud-mary.chopro": "9570",
  "./redemption-song.chopro": "2291",
  "./riptide.chopro": "5449",
  "./should-i-stay-or-should-i-go.chopro": "9182",
  "./smoke-on-the-water.chopro": "81",
  "./stand-by-me.chopro": "4857",
  "./sultans-of-swing.chopro": "8661",
  "./summer-of-69.chopro": "4145",
  "./sweet-child-o-mine.chopro": "9037",
  "./sweet-home-alabama.chopro": "5442",
  "./take-me-home-country-roads.chopro": "2453",
  "./three-little-birds.chopro": "9614",
  "./twist-and-shout.chopro": "6137",
  "./use-somebody.chopro": "7874",
  "./wagon-wheel.chopro": "2600",
  "./wish-you-were-here.chopro": "5222",
  "./wonderwall.chopro": "443",
  "./zombie.chopro": "1410"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 5107;
